import { useDashboard } from '../contexts/DashboardContext';
import LeagueTableCard from '../components/LeagueTableCard';
import PriceHistoryCard from '../components/PriceHistoryCard';
import ExpectedPointsCard from '../components/ExpectedPointsCard';
import LeaguePositionCard from '../components/LeaguePositionCard';
import PositionProbabilitiesCard from '../components/PositionProbabilitiesCard';
import ScoreMatrixCard from '../components/ScoreMatrixCard';
import MarketOverviewCard from '../components/MarketOverviewCard';
import MatchOddsPricingCard from '../components/MatchOddsPricingCard';
import MatchPriceChartCard from '../components/MatchPriceChartCard';

export default function Home() {
  const { loading, error } = useDashboard();

  if (loading) {
    return (
      <div className="text-center mt-5"><div className="spinner-border" /></div>
    );
  }

  if (error) {
    return (
      <div className="container py-4">
        <div className="alert alert-danger">{error}</div>
      </div>
    );
  }

  return (
    <div className="container-fluid py-3 px-3 px-md-4">
      <div className="row g-3">
        <div className="col-12 col-md-6 col-lg-4">
          <LeagueTableCard />
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <PriceHistoryCard />
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <ExpectedPointsCard />
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <LeaguePositionCard />
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <PositionProbabilitiesCard />
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <ScoreMatrixCard />
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <MarketOverviewCard />
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <MatchOddsPricingCard />
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <MatchPriceChartCard />
        </div>
      </div>
    </div>
  );
}
